import React from "react";

import { Reaction } from "workstep/pages/Feedback/Comments/state/types";

const REACTIONS: Reaction[] = [
    { emoji: "🎉", type: "TADA" },
    { emoji: "👍️", type: "THUMBS_UP" },
    { emoji: "✔️", type: "CHECK" },
    { emoji: "👎️", type: "THUMBS_DOWN" },
];

type Props = {
    reaction?: Maybe<Reaction>;
    onChange: (value: Maybe<Reaction>) => void;
    disabled?: boolean;
};

const ReactionPicker = ({ reaction, onChange, disabled = false }: Props) => {
    const handleChange = (r: Maybe<Reaction>) => {
        if (r?.type === reaction?.type) {
            onChange(null);
        } else {
            onChange(r);
        }
    };
    return (
        <div className="ws-reaction-picker__container">
            {REACTIONS.map((r) => (
                <button
                    key={r.type}
                    className={`ws-reaction-picker__reaction ${
                        reaction?.type === r.type ? "selected" : ""
                    }`}
                    onClick={() => handleChange(r)}
                    disabled={disabled}
                >
                    {r.emoji}
                </button>
            ))}
        </div>
    );
};

export default ReactionPicker;
